const STORAGE_PREFIX = 'training-program-optional-drills';

export type OptionalDrillSelection = {
  drillIds: string[];
};

const getStorageKey = (planId: string) => `${STORAGE_PREFIX}:${planId}`;

export const loadOptionalDrillSelection = (planId: string): OptionalDrillSelection => {
  if (!planId || typeof window === 'undefined') {
    return { drillIds: [] };
  }

  const raw = window.localStorage.getItem(getStorageKey(planId));
  if (!raw) {
    return { drillIds: [] };
  }

  try {
    const parsed = JSON.parse(raw) as OptionalDrillSelection;
    if (!parsed || !Array.isArray(parsed.drillIds)) {
      return { drillIds: [] };
    }
    return { drillIds: parsed.drillIds.filter(Boolean) };
  } catch {
    return { drillIds: [] };
  }
};

export const saveOptionalDrillSelection = (planId: string, drillIds: string[]) => {
  if (!planId || typeof window === 'undefined') return;
  const payload: OptionalDrillSelection = { drillIds: drillIds.filter(Boolean) };
  window.localStorage.setItem(getStorageKey(planId), JSON.stringify(payload));
};

export const addOptionalDrill = (planId: string, drillId: string, maxCount: number) => {
  if (!planId || !drillId) return;
  const current = loadOptionalDrillSelection(planId).drillIds;
  if (current.includes(drillId)) return;
  const next = [...current, drillId].slice(0, maxCount);
  saveOptionalDrillSelection(planId, next);
};

export const removeOptionalDrill = (planId: string, drillId: string) => {
  if (!planId || !drillId) return;
  const current = loadOptionalDrillSelection(planId).drillIds;
  const next = current.filter((id) => id !== drillId);
  saveOptionalDrillSelection(planId, next);
};
